import { render, staticRenderFns } from "./BadRequest.vue?vue&type=template&id=0aa0a35c&scoped=true"
import script from "./BadRequest.vue?vue&type=script&lang=ts"
export * from "./BadRequest.vue?vue&type=script&lang=ts"
import style0 from "./BadRequest.vue?vue&type=style&index=0&id=0aa0a35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa0a35c",
  null
  
)

export default component.exports